import { getEmptyTranslations } from '@/configuration/pages/ConfigurationPage/helpers'
import { actionTypeValues } from '@/configuration/pages/ConfigurationPage/ReturnReasonsConfiguration/ReturnReasonDetailConfiguration/ActionsSection/constants'
import { returnReasonsFilteringTypes } from '@/configuration/pages/ConfigurationPage/ReturnReasonsConfiguration/ReturnReasonDetailConfiguration/constants'

export const getSelectedCategories = returnReason => {
  return returnReason?.product_external_categories?.map(category => category.id) ?? []
}

export const getSelectedProductTypes = (productTypes, returnReason) => {
  return (
    productTypes
      ?.filter(productType => returnReason?.product_types?.includes(productType.name))
      .map(productType => productType.name) ?? []
  )
}

export const getCreateReturnReasonPayload = ({
  selectedType,
  useCustomTitle,
  customTitles,
  notesValidation,
  imageValidation,
  transactionTypes,
  selectedCategories,
  actionForTransactionTypes,
  useCustomMessage,
  customMessages,
  selectedProductTypes,
  subReasons,
  returnReasonsFiltering,
  availabilityMode,
  action,
  bonusTypes,
  tags,
  matchCase,
}) => {
  const payload = {
    key: selectedType,
    display: useCustomTitle ? customTitles : {},
    notes_validation: notesValidation,
    image_validation: imageValidation,
    transaction_types: transactionTypes,
    availability_mode: availabilityMode,
    product_external_category_ids: [],
    action_for_transaction_types: [actionTypeValues.block, actionTypeValues.onHold].includes(action)
      ? actionForTransactionTypes
      : [],
    custom_message: useCustomMessage ? customMessages : {},
    product_types: [],
    product_tags: [],
    product_tags_case_sensitive: false,
    subreasons: subReasons.map((subReason, index) => ({
      key: subReason.key,
      internal_name: subReason.internal_name,
      display: subReason.display,
      position: index,
    })),
    action,
    bonus_types: action === actionTypeValues.bonus ? bonusTypes : [],
  }

  if (returnReasonsFiltering?.includes(returnReasonsFilteringTypes.productTypes)) {
    payload.product_types = selectedProductTypes
  }

  if (returnReasonsFiltering?.includes(returnReasonsFilteringTypes.productCategories)) {
    payload.product_external_category_ids = selectedCategories
  }

  if (returnReasonsFiltering?.includes(returnReasonsFilteringTypes.productTags)) {
    payload.product_tags = tags
    payload.product_tags_case_sensitive = matchCase
  }

  return payload
}

export const getEditReturnReasonPayload = ({
  returnReasonToEdit,
  selectedType,
  useCustomTitle,
  customTitles,
  notesValidation,
  imageValidation,
  transactionTypes,
  selectedCategories,
  actionForTransactionTypes,
  useCustomMessage,
  customMessages,
  supportedLanguages,
  selectedProductTypes,
  subReasons,
  returnReasonsFiltering,
  availabilityMode,
  action,
  bonusTypes,
  tags,
  matchCase,
}) => {
  const emptyTranslations = getEmptyTranslations(supportedLanguages)
  const display = useCustomTitle ? customTitles : emptyTranslations

  const payload = {
    ...returnReasonToEdit,
    key: selectedType,
    display,
    image_validation: imageValidation,
    notes_validation: notesValidation,
    transaction_types: transactionTypes,
    availability_mode: availabilityMode,
    product_external_category_ids: [],
    action_for_transaction_types: [actionTypeValues.block, actionTypeValues.onHold].includes(action)
      ? actionForTransactionTypes
      : [],
    custom_message: useCustomMessage ? customMessages : emptyTranslations,
    product_types: [],
    product_tags: [],
    product_tags_case_sensitive: false,
    subreasons: subReasons.map((subReason, index) => ({
      id: subReason.id.includes('new-') ? undefined : subReason.id,
      key: subReason.key,
      internal_name: subReason.internal_name,
      display: subReason.display,
      position: index,
    })),
    action,
    bonus_types: action === actionTypeValues.bonus ? bonusTypes : [],
  }

  if (returnReasonsFiltering?.includes(returnReasonsFilteringTypes.productTypes)) {
    payload.product_types = selectedProductTypes
  }

  if (returnReasonsFiltering?.includes(returnReasonsFilteringTypes.productCategories)) {
    payload.product_external_category_ids = selectedCategories
  }

  if (returnReasonsFiltering?.includes(returnReasonsFilteringTypes.productTags)) {
    payload.product_tags = tags
    payload.product_tags_case_sensitive = matchCase
  }

  return payload
}

export const getNewSubReasonObject = (languages, subReasons) => {
  return {
    id: `new-${Math.random()}`,
    internal_name: `Subreason #${subReasons?.length + 1}`,
    key: `subreason_${subReasons?.length + 1}`,
    display: Object.fromEntries(languages.map(lang => [lang, ''])),
  }
}
